import { configureStore } from "@reduxjs/toolkit";
import ForgotPswdCounterSliceReducer from "./ForgotpswdCounterSlice";
import ChatFlagReducer from "./ChatFlagSlice";
import deleteFlag from "./DeleteModelFlagSlice";


const store = configureStore({
  reducer: {
    ForgotpswdCounter: ForgotPswdCounterSliceReducer,
    ChatFlag: ChatFlagReducer,
    DeleteFlag: deleteFlag,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export default store;
